import { Link } from 'react-router-dom'
import './PrivacyPolicy.css'

function PrivacyPolicy() {
  return (
    <div className="privacy-policy">
      <div className="privacy-policy-container">
        <div className="privacy-policy-header">
          <Link to="/" className="back-link">← Zpět na hlavní stránku</Link>
          <h1>Zásady ochrany osobních údajů</h1>
          <p className="last-updated">Poslední aktualizace: 5. prosince 2025</p>
        </div>

        <div className="privacy-policy-content">
          <section>
            <h2>1. Úvod</h2>
            <p>
              Integrovaná střední škola Cheb (dále jen "škola" nebo "my") respektuje vaše soukromí 
              a zavazuje se chránit vaše osobní údaje v souladu s Nařízením Evropského parlamentu 
              a Rady (EU) 2016/679 ze dne 27. dubna 2016 o ochraně fyzických osob v souvislosti 
              se zpracováním osobních údajů (GDPR) a zákonem č. 110/2019 Sb., o zpracování osobních údajů.
            </p>
          </section>

          <section>
            <h2>2. Správce osobních údajů</h2>
            <p>
              <strong>Integrovaná střední škola Cheb, příspěvková organizace</strong><br />
              Obrněné brigády 2258/6<br />
              350 02 Cheb<br />
              Česká republika<br />
              <br />
              <strong>Kontaktní údaje:</strong><br />
              Tel./Fax.: +420 354 408 011, +420 734 522 684<br />
              E-mail: info@iss-cheb.cz<br />
              ID datové schránky: tvbsw8x<br />
              <br />
              <strong>Identifikační údaje:</strong><br />
              IČO: 00077461<br />
              DIČ: CZ00077461<br />
              RED IZO: 600170462<br />
              IZO: 130002046<br />
              Bankovní účet: 21636331/0100<br />
              <br />
              <strong>Kontaktní osoba pro ochranu osobních údajů:</strong><br />
              E-mail: info@iss-cheb.cz<br />
              Telefon: +420 354 408 011
            </p>
          </section>

          <section>
            <h2>3. Jaké osobní údaje zpracováváme</h2>
            <p>V rámci provozu intranetového systému zpracováváme následující osobní údaje:</p>
            <ul>
              <li><strong>Identifikační údaje:</strong> Jméno, příjmení</li>
              <li><strong>Kontaktní údaje:</strong> Emailová adresa (pro autentizaci přes Microsoft Office 365)</li>
              <li><strong>Údaje o uživateli:</strong> Role v systému (žadatel, administrátor, řešitel, student, zaměstnanec)</li>
              <li><strong>Technické údaje:</strong> IP adresa (pro bezpečnost a diagnostiku)</li>
              <li><strong>Obsahové údaje:</strong> Data zadaná v rámci žádostí, tiketů a dalších funkcí systému</li>
            </ul>
          </section>

          <section>
            <h2>4. Účel zpracování osobních údajů</h2>
            <p>Vaše osobní údaje zpracováváme za následujícími účely:</p>
            <ul>
              <li><strong>Autentizace a autorizace:</strong> Zajištění bezpečného přístupu k systému prostřednictvím Microsoft Office 365</li>
              <li><strong>Provoz systému:</strong> Správa žádostí, tiketů, nákupních požadavků a dalších funkcí intranetu</li>
              <li><strong>Komunikace:</strong> Odesílání notifikací a emailových zpráv souvisejících s provozem systému</li>
              <li><strong>Bezpečnost:</strong> Ochrana systému před neoprávněným přístupem a zajištění bezpečnosti dat</li>
              <li><strong>Statistiky:</strong> Anonymní analýza používání systému pro zlepšení služeb</li>
            </ul>
          </section>

          <section>
            <h2>5. Právní základ zpracování</h2>
            <p>Zpracování osobních údajů je založeno na:</p>
            <ul>
              <li><strong>Plnění právní povinnosti:</strong> Škola je povinna vést evidenci zaměstnanců a studentů</li>
              <li><strong>Oprávněný zájem:</strong> Zajištění bezpečnosti a provozu informačního systému školy</li>
              <li><strong>Souhlas:</strong> V některých případech může být zpracování založeno na vašem souhlasu</li>
            </ul>
          </section>

          <section>
            <h2>6. Doba uchování osobních údajů</h2>
            <p>
              Osobní údaje uchováváme pouze po dobu nezbytnou pro naplnění účelů, pro které byly shromážděny, 
              nebo po dobu stanovenou právními předpisy. Po uplynutí této doby jsou osobní údaje bezpečně smazány.
            </p>
            <ul>
              <li><strong>Údaje o uživatelích:</strong> Po dobu trvání pracovního poměru nebo studia</li>
              <li><strong>Žádosti a tikety:</strong> Po dobu nezbytnou pro vyřízení a archivaci (obvykle 3-5 let)</li>
              <li><strong>Logy a technické údaje:</strong> Maximálně 1 rok</li>
            </ul>
          </section>

          <section>
            <h2>7. Předávání osobních údajů</h2>
            <p>
              Vaše osobní údaje mohou být předány následujícím subjektům:
            </p>
            <ul>
              <li><strong>Microsoft Corporation:</strong> Pro účely autentizace přes Azure AD (Office 365) - údaje jsou zpracovávány v souladu s jejich zásadami ochrany osobních údajů</li>
              <li><strong>Poskytovatelé hostingových služeb:</strong> Pro technické zajištění provozu systému (údaje jsou uloženy v datacentrech v Evropské unii)</li>
              <li><strong>Orgány veřejné moci:</strong> V případech, kdy to vyžaduje zákon</li>
            </ul>
            <p>
              <strong>Důležité:</strong> Vaše osobní údaje nejsou předávány do třetích zemí mimo Evropskou unii.
            </p>
          </section>

          <section>
            <h2>8. Vaše práva</h2>
            <p>V souladu s GDPR máte následující práva:</p>
            <ul>
              <li><strong>Právo na přístup k údajům:</strong> Můžete požádat o informace o tom, jaké osobní údaje o vás zpracováváme</li>
              <li><strong>Právo na opravu:</strong> Můžete požádat o opravu nepřesných nebo neúplných údajů</li>
              <li><strong>Právo na výmaz:</strong> Můžete požádat o smazání vašich osobních údajů (s výjimkou případů, kdy je zpracování povinné ze zákona)</li>
              <li><strong>Právo na omezení zpracování:</strong> Můžete požádat o omezení zpracování vašich údajů</li>
              <li><strong>Právo na přenositelnost údajů:</strong> Můžete požádat o předání vašich údajů v strukturovaném formátu</li>
              <li><strong>Právo vznést námitku:</strong> Můžete vznést námitku proti zpracování vašich údajů</li>
              <li><strong>Právo odvolat souhlas:</strong> Pokud je zpracování založeno na souhlasu, můžete souhlas kdykoli odvolat</li>
              <li><strong>Právo podat stížnost:</strong> Můžete podat stížnost u Úřadu pro ochranu osobních údajů (www.uoou.cz)</li>
            </ul>
          </section>

          <section>
            <h2>9. Bezpečnost osobních údajů</h2>
            <p>
              Zavazujeme se chránit vaše osobní údaje pomocí vhodných technických a organizačních opatření:
            </p>
            <ul>
              <li>Šifrování dat při přenosu (HTTPS/TLS)</li>
              <li>Bezpečné ukládání dat v databázi</li>
              <li>Pravidelné aktualizace a bezpečnostní kontroly</li>
              <li>Omezený přístup k osobním údajům pouze pro oprávněné osoby</li>
              <li>Pravidelné zálohování dat</li>
              <li>Monitorování bezpečnostních incidentů</li>
            </ul>
          </section>

          <section>
            <h2>10. Cookies a technologie sledování</h2>
            <p>
              Náš systém používá technické cookies nezbytné pro fungování systému (např. pro autentizaci). 
              Tyto cookies nevyžadují váš souhlas podle platné legislativy.
            </p>
            <p>
              <strong>Používané cookies:</strong>
            </p>
            <ul>
              <li><strong>Session cookies:</strong> Pro udržení přihlášení uživatele</li>
              <li><strong>Autentizační tokeny:</strong> Pro bezpečnou autentizaci přes JWT</li>
            </ul>
          </section>

          <section>
            <h2>11. Změny zásad ochrany osobních údajů</h2>
            <p>
              Tyto zásady ochrany osobních údajů mohou být čas od času aktualizovány. 
              O významných změnách vás budeme informovat prostřednictvím systému nebo emailu.
            </p>
          </section>

          <section>
            <h2>12. Kontakt</h2>
            <p>
              Pokud máte jakékoli dotazy ohledně zpracování vašich osobních údajů nebo chcete uplatnit 
              svá práva, kontaktujte nás:
            </p>
            <p>
              <strong>Integrovaná střední škola Cheb, příspěvková organizace</strong><br />
              Obrněné brigády 2258/6<br />
              350 02 Cheb<br />
              Česká republika<br />
              <br />
              <strong>Kontaktní údaje:</strong><br />
              Tel./Fax.: +420 354 408 011, +420 734 522 684<br />
              E-mail: info@iss-cheb.cz<br />
              ID datové schránky: tvbsw8x<br />
              <br />
              <strong>Identifikační údaje:</strong><br />
              IČO: 00077461<br />
              DIČ: CZ00077461
            </p>
          </section>

          <section className="consent-section">
            <h2>13. Souhlas se zpracováním osobních údajů</h2>
            <p>
              Používáním tohoto systému potvrzujete, že jste se seznámili s těmito zásadami ochrany 
              osobních údajů a souhlasíte se zpracováním vašich osobních údajů v rozsahu a za účelem 
              uvedeným v těchto zásadách.
            </p>
          </section>
        </div>

        <div className="privacy-policy-footer">
          <Link to="/" className="back-link">← Zpět na hlavní stránku</Link>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicy

